module.exports = __webpack_public_path__ + "img/mon_rotated.42252841.png";